import React, { useMemo, useState, useEffect } from 'react';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import styles from 'pages/general/admin/manage_task/style.module.scss';
import styles1 from '../style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import { useLocation, useNavigate } from 'react-router-dom';
import { calculateDifferenceInHours } from 'shared/utils/Helper';
import ModalImage from 'shared/components/common/custom_image_lightbox/ModalImage';
import useCountdown from '../../hook/useCountDown';
import UploadAvatarArray from 'shared/components/common/upload_avatar/UploadAvatarArray';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { taskEnum } from 'shared/utils/Enum';
import { SubmitTaskMutation } from 'shared/services/task_service/TaskService';
import { toastMessage } from 'shared/components/toast/Toast';

export default function Wopt() {
    const navigate = useNavigate();
    const { mutate: submitTaskMutate, isLoading: UpdateTaskIsLoading, isSuccess: UpdateTaskIsSuccess } = SubmitTaskMutation();
    const [avatarFile, setAvatarFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState('');
    const [avatarFileArray, setAvatarFileArray] = useState([]);
    const location = useLocation();
    const tasks = location?.state?.taskInprogress;

    const task_time = useMemo(() => {
        let differenceInSeconds = '';
        if (tasks?.status !== taskEnum.COMPLETED) {
            const givenDateStr = tasks?.task_assigned_date;
            const givenDate = new Date(givenDateStr);
            const currentDate = new Date();
            differenceInSeconds = calculateDifferenceInHours(currentDate, givenDate);
        }
        if (tasks?.status === taskEnum.COMPLETED) {
            let task_detail = {
                assigned_date: tasks?.task_assigned_date,
                completed_date: tasks?.task_completed_date || new Date()
            };
            differenceInSeconds = calculateTimeDifference(task_detail.assigned_date, task_detail.completed_date);
        }

        return differenceInSeconds;
    }, [tasks]);
    useEffect(() => {
        setAvatarFileArray(tasks?.designed_images || []);
    }, [tasks, tasks?.task_assigned_date, tasks?.task_completed_date]);

    useEffect(() => {
        if (UpdateTaskIsSuccess) {
            navigate(-1);
        }
    }, [UpdateTaskIsSuccess]);
    const { hours, minutes, seconds, isNegative, stopTimer } = useCountdown(task_time);
   const uploadMediaArray = async (files) => {
  try {
    let cloneAvatarFile = [...avatarFileArray];

    for (let file of files) {
      let fileBody = new FormData();
      fileBody.append("image", file);
      const imgfileArray = await uploadFileMedia(fileBody);
      const newurl = imgfileArray.data.url;
      cloneAvatarFile.push(newurl);
    }

    setAvatarFileArray(cloneAvatarFile);
  } catch (error) {
    console.error("Upload error:", error);
  }
};

    const handleSubmit = () => {
        if (!avatarFileArray || avatarFileArray.length === 0) {
            toastMessage('error', 'Images are required for submission');
            return;
        }
        let id = tasks?._id;
        let obj = {
            status: taskEnum.COMPLETED,
            designed_images: avatarFileArray,
            task_completed_date: new Date().toISOString()
        };
        if (isNegative) {
            obj['earned_point'] = 0;
        }
        if (!isNegative) {
            obj['earned_point'] = Number(tasks?.task_point);
        }
        const payload = {
            id: id,
            body: obj
        };
        submitTaskMutate(payload);
        stopTimer();
    };
    function calculateTimeDifference(assignedDateStr, completedDateStr) {
        const assignedDate = new Date(assignedDateStr);
        const completedDate = new Date(completedDateStr);

        const timeDifference = assignedDate - completedDate;

        const absTimeDifference = Math.abs(timeDifference);

        const hours = Math.floor(absTimeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((absTimeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((absTimeDifference % (1000 * 60)) / 1000);

        return {
            hours,
            minutes,
            seconds,
            isNegative: timeDifference < 0
        };
    }

    const convertPointIntoHour = (task_point = 0) => {
        let task_time = {
            hours: 0,
            minutes: 0
        };
        task_point.split('.').map((point, inx) => {
            if (Number(point) && inx === 0) {
                task_time.hours = Number(point);
            }

            if (Number(point) && inx) {
                task_time.minutes = Number(point);
            }
        });
        return task_time;
    };
    const { hours: taskHour, minutes: taskMinutes } = convertPointIntoHour(tasks?.task_point);

    const actualTimeLog = () => {
        let task_detail = {
            assigned_date: tasks?.task_assigned_date,
            completed_date: tasks?.task_completed_date || new Date()
        };
        
        const assignedDateMs = new Date(task_detail.assigned_date).getTime();
        const completedDateMs = new Date(task_detail.completed_date).getTime();
        
        // Exact elapsed time in seconds
        let elapsedSeconds = (completedDateMs - assignedDateMs) / 1000;
        if (elapsedSeconds < 0) elapsedSeconds = 0;
        
        const hours = Math.floor(elapsedSeconds / 3600);
        const minutes = Math.floor((elapsedSeconds % 3600) / 60);
        const seconds = Math.floor(elapsedSeconds % 60);
        
        return {
            hours,
            minutes,
            seconds
        };
    };
    const { hours: loggedHour, minutes: loggedMinutes, seconds: loggedSeconds } = actualTimeLog();

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div className={styles.Header}>
                    <div>
                        <Heading heading={`Task : ${tasks.name}`} headingStyle={styles.Heading} />
                        {tasks?.status === taskEnum.COMPLETED && (
                            <Heading
                                heading={`Your expected time is ${taskHour ? taskHour + ' hour' : ''} ${taskMinutes ? taskMinutes + ' mins' : ''} but you completed this task in ${
                                    loggedHour > 0 ? loggedHour + 'h ' : ''
                                }${loggedMinutes}m ${loggedSeconds}s`}
                                headingStyle={styles.Heading}
                            />
                        )}
                    </div>
                    <h4 className="d-flex justify-content-center" headingStyle={styles.Heading}>
                        {tasks?.status === taskEnum.COMPLETED ? (
                            <>
                                {task_time.isNegative ? '-' : ''} {task_time.hours}h {task_time.minutes}m {task_time.seconds}s
                            </>
                        ) : (
                            <>
                                {isNegative ? '-' : ''} {hours}h {minutes}m {seconds.toFixed(0)}s
                            </>
                        )}
                    </h4>
                </div>
                <div className={styles.Mainflex}>
                    <div className={classNames(styles.AddLinkContainer)}>
                        <div className={styles1.DetailsGrid}>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>SKU</span>
                                <span className={styles1.DetailValue}>{tasks?.task_inventory?.sku || tasks?.task_sku || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Brand</span>
                                <span className={styles1.DetailValue}>{tasks?.task_brand?.name || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Compatible Brand</span>
                                <span className={styles1.DetailValue}>{tasks?.task_compatiableBrand?.name || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Model</span>
                                <span className={styles1.DetailValue}>{tasks?.task_product?.name || tasks?.task_product?.model || (tasks?.name && tasks?.name !== 'Rough Listing Item' ? tasks?.name : '') || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Category</span>
                                <span className={styles1.DetailValue}>{tasks?.task_category?.name || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Sub Category</span>
                                <span className={styles1.DetailValue}>{tasks?.task_subcategory?.name || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Color</span>
                                <span className={styles1.DetailValue}>{tasks?.task_inventory?.color || tasks?.task_color || tasks?.color || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Task Priority</span>
                                <span className={styles1.DetailValue}>{tasks?.priority || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Task Status</span>
                                <span className={styles1.DetailValue}>{tasks?.status || 'N/A'}</span>
                            </div>
                            <div className={styles1.DetailItem}>
                                <span className={styles1.DetailLabel}>Task Points</span>
                                <span className={styles1.DetailValue}>{tasks?.task_point || '0'}</span>
                            </div>
                        </div>
                        <div className={styles1.DetailItemFull}>
                            <span className={styles1.DetailLabel}>Task Comments</span>
                            <span className={styles1.DetailValue}>{tasks?.comments || 'N/A'}</span>
                        </div>
                        <div className={styles.taskviews}>
                            <label>Rectifired Images</label>
                            {tasks.rectifired_images && (
                                <div className={classNames(styles1.TableFlex)}>
                                    {tasks.rectifired_images.map((item, index) => {
                                        return (
                                            <div className={`p-0  ${styles.Avatar}`} role={'button'}>
                                                <label className={classNames('position-relative', styles.UploadAvatarContainer)} role={'button'}>
                                                    <ModalImage 
                                                        small={item} 
                                                        large={item} 
                                                        alt={tasks?.task_product?.name} 
                                                        className={classNames(styles.profileImages)} 
                                                        imageArray={tasks.rectifired_images}
                                                        currentIndex={index}
                                                    />
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className={styles.taskviews}>
                            <label>Designed Images</label>
                            {tasks?.status !== taskEnum.COMPLETED ? (
                                <UploadAvatarArray
                                    setAvatarFileArray={setAvatarFileArray}
                                    edittask={true}
                                    UploadedFile={avatarFile}
                                    avatarFileArray={avatarFileArray}
                                    setArray={uploadMediaArray}
                                    setFile={setAvatarFile}
                                    selectedImg={selectedImg}
                                    setSelectedImg={setSelectedImg}
                                />
                            ) : (
                                <div className={classNames(styles1.TableFlex)}>
                                    {tasks.designed_images.map((item, index) => {
                                        return (
                                            <div className={`p-0  ${styles.Avatar}`} role={'button'}>
                                                <label className={classNames('position-relative', styles.UploadAvatarContainer)} role={'button'}>
                                                    <ModalImage 
                                                        small={item} 
                                                        large={item} 
                                                        alt={tasks?.task_product?.name} 
                                                        className={classNames(styles.profileImages)} 
                                                        imageArray={tasks.designed_images}
                                                        currentIndex={index}
                                                    />
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        {tasks?.status !== taskEnum.COMPLETED ? (
                            <div className="d-flex justify-content-start">
                                <CustomButton
                                    text={'Submit'}
                                    containerStyle={styles1.SubmitBtn}
                                    submitHandle={() => {
                                        handleSubmit();
                                    }}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </DashboardWrapper>
    );
}
